import { getCartProductMarkup } from '@archetype-themes/modules/cart';

const flktyElement = document.querySelector('.giftcard-recommendations__slider');
let flktyInstance = null;

function initOrDestroyFlickity() {
    if (!flktyElement) return;

    if (window.innerWidth >= 768) {
        if (!flktyInstance) {
            flktyInstance = new Flickity(flktyElement, {
                cellAlign: 'left',
                contain: true,
                groupCells: true,
                pageDots: false,
                prevNextButtons: true
            });
        }
    } else {
        if (flktyInstance) {
            flktyInstance.destroy();
            flktyInstance = null;
        }
    }
}

// Init on load
document.addEventListener("DOMContentLoaded", initOrDestroyFlickity())

// Re-check on resize
window.addEventListener('resize', initOrDestroyFlickity);

document.addEventListener('click', async (event) => {
    const btn = event.target.closest('.add-suggestion-btn');
    if (!btn) return;

    let variantId = btn.getAttribute('data-variant-id');

    const wrapper = btn.closest('.giftcard-recommendations__item');

    if (!variantId) {
        const select = wrapper?.querySelector('.variant-dropdown');
        if (select) {
            variantId = select.value;
        }
    }

    if (!variantId) {
        console.warn('No variant ID found for recommendation add');
        return;
    }

    let quantity = 1;
    const quantityInput = wrapper?.querySelector('.recommendation-quantity-input');
    if (quantityInput) {
        const parsed = parseInt(quantityInput.value, 10);
        if (!isNaN(parsed) && parsed > 0) {
            quantity = parsed;
        }
    }

    btn.disabled = true;
    btn.textContent = 'Adding...';

    try {
        const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: variantId, quantity }),
        });

        if (res.ok) {
            document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));

            // Fetch updated cart HTML
            const cartDrawer = document.querySelector('header-cart-drawer');
            const container = cartDrawer?.querySelector('[data-products]');

            if (container) {
                getCartProductMarkup().then((html) => {
                    const temp = document.createElement('div');
                    temp.innerHTML = html;

                    const newContent = temp.querySelector('[data-products]');
                    if (newContent) container.innerHTML = newContent.innerHTML;
                });
            }

            btn.textContent = 'Added';
        } else {
            btn.textContent = 'Error';
        }
    } catch (err) {
        console.error(err);
        btn.textContent = 'Error';
    } finally {
        setTimeout(() => {
            btn.disabled = false;
            btn.textContent = '+ ADD';
        }, 2000);
    }
});